export enum FilterScope {
  Account = 'Account',
  Publisher = 'Publisher'
}